exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#airbnb-accounts-disconnect-table{margin-top:25px;background:#fff}.title-card{color:#c52c36;font-size:14px;font-weight:500;line-height:29px}#airbnb-accounts-table{margin-top:10px!important;background:#fff}.disconnect-btn{-ms-flex-line-pack:center;align-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-68a4bb20","scoped":false,"hasInlineConfig":false}!./src/app/pages/account/airbnb-account/airbnbAccount.css
// module id = 1121
// module chunks = 0